// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3G1Md","errorLogs":"EditorFooter_errorLogs__SYp9R"};